export default __webpack_public_path__ + "static/avatar-kayi-common-2-cover-f96729405180eb706e1a39d2a136566d.png";